import { useCallback, useState } from 'react'
import { useSlate } from 'slate-react'

import {
  getMicrosoftFileUrl,
  MICROSOFT_APPS_EXTENSIONS,
} from 'core-components/helpers/microsoftFilesHelper'
import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'
import { FILE_AVAILABLE_MIME_TYPES } from 'core-components/library/richTextEditor/constants'
import {
  insertIFrame,
  insertVideo,
} from 'core-components/library/richTextEditor/helpers/slateHelper'
import { TOOLBAR_BUTTONS } from 'core-components/library/richTextEditor/interface/IToolbar'

import { TOOLBAR_TITLES } from '../../constants'

import { DEFAULT_FRAME_HEIGHT, DEFAULT_VIDEO_HEIGHT } from './constants'
import { FileDialog, IFileInfo } from './FileDialog'

interface IProps {
  disabled: boolean
  className?: string
}

export function FileButton(props: IProps) {
  const [headerVisible, setHeaderVisible] = useState(false)
  const editor = useSlate()

  const onClose = useCallback(() => {
    setHeaderVisible(false)
  }, [])

  const insertFiles = useCallback(
    (files: IFileInfo[]) => {
      files.forEach((item) => {
        if (!item.url) {
          return
        }
        const splitted = item.data.file.name.split('.')
        const ext = splitted[splitted.length - 1]
        const isAvailableType = FILE_AVAILABLE_MIME_TYPES.some((el) => ext === el.name)
        if (!isAvailableType) {
          return
        }
        if (item.data.file.type === 'video/mp4') {
          insertVideo(editor, {
            url: item.url,
            height: DEFAULT_VIDEO_HEIGHT,
          })
          return
        }
        let url = item.url
        if (MICROSOFT_APPS_EXTENSIONS.includes(ext)) {
          url = getMicrosoftFileUrl(item.url)
        }
        insertIFrame(editor, { url, height: DEFAULT_FRAME_HEIGHT, name: item.data.file.name })
      })
      onClose()
    },
    [editor, onClose]
  )

  return (
    <>
      <Button
        className={props.className}
        onClick={() => setHeaderVisible(true)}
        title={TOOLBAR_TITLES[TOOLBAR_BUTTONS.UploadFile]}
        disabled={props.disabled || !editor.fileUploadAdapter}
        iconButton={'kbase kbase-editor-add-file'}
        variant={'text'}
        color={'grey'}
      />
      <ModalDialog
        title={'Upload file'}
        content={() => <FileDialog onClose={onClose} insertFiles={insertFiles} />}
        size={'auto'}
        onClose={onClose}
        show={headerVisible}
      />
    </>
  )
}
